import NProgress from 'nprogress' // progress bar
import router from './router'
import store from './store'
import 'nprogress/nprogress.css' // progress bar style
import { getToken, removeToken } from '@/utils/auth' // get token from cookie

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    // start progress bar
    NProgress.start()

    // set page title
    // document.title = getPageTitle(to.meta.title)

    // determine whether the user has logged in
    const hasToken = getToken()
    //console.log('hasToken ', hasToken)
    if (hasToken) {
        if (to.path === '/login') {
            // if is logged in, redirect to the home page
            next({ path: '/app/ventas' })
            NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-app/pull/2939
        } else {
            // determine whether the user has obtained his permission roles through getInfo
            const hasRoles = true
            //console.log('hasRoles ', hasRoles)
            if (hasRoles) {
                next()
            } else {
                try {
                    const body = { ...to, replace: true }
                    next(body)
                } catch (error) {
                    // remove token and go to login page to re-login
                    await store.dispatch('users/resetToken')
                    // Message.error(error || 'Has Error')
                    next(`/login?redirect=${to.path}`)
                    NProgress.done()
                }
            }
        }
    } else {
        /* has no token */
        /* has no token */
        removeToken()
        localStorage.clear()
        if (whiteList.indexOf(to.path) !== -1) {
            localStorage.clear()

            // in the free login whitelist, go directly
            next()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next(`/login?redirect=${to.path}`)
            NProgress.done()
        }
    }
})

router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})
